<template>
  <div id="box">
    <dv-full-screen-container>
      <vue-particles v-if="flg" color="#dedede" :particleOpacity="0.7" :particlesNumber="80" shapeType="edge" :particleSize="4" linesColor="#dedede" :linesWidth="1" :lineLinked="true"
                     :lineOpacity="0.5" :linesDistance="150" :moveSpeed="6" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
      </vue-particles>
      <div class="box-card">
        <el-card>
          <el-form :model="form" :rules="rules" @keydown.enter.native="onSubmit" class="login-box" label-width="25%"
                   ref="login">
            <div class="title">农业四情</div>
            <el-input prefix-icon="el-icon-s-custom" placeholder="请输入邮箱" v-model="form.email" class="inputEmail"></el-input>
            <el-input prefix-icon="el-icon-lock" placeholder="请输入密码"  type="password" v-model="form.password" class="inputPwd"></el-input>
            <el-button @click="onSubmit" type="primary" round class="loginBtn" style="position: relative;">登录</el-button>
          </el-form>
        </el-card>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
  import router from "../../router"
  import {getAuth, userLogin} from "../../until/api/login";
  export default {
    name: 'Login',
    components:{},
    data() {
      return {
        form: {
          email: "",
          password: "",
        },
        rules: {
          email: [
            {required: true, message: "电子邮箱不可为空", trigger: "blur"},
          ],
          password: [
            {required: true, message: "密码不可为空", trigger: "blur"},
          ],
        },
        flg: true,
      }
    },

    mounted() {

    },

    methods: {
      /**
       * 登录获取token
       */
      onSubmit() {
        let param = {"username":this.form.email, "password": this.form.password};
        userLogin(param).then(response => {
          localStorage.setItem('login', this.$commonFun.compileStr(JSON.stringify(param)));
          //localStorage.setItem('login', JSON.stringify(param));

          //localStorage.setItem('token', response.data.token);
          localStorage.setItem('token', this.$commonFun.compileStr(response.data.token));
          this.getAuthority();
        }).catch(error => {
          this.$message({
            showClose: true,
            type:'warning',
            message: '用户名或密码错误，请重新输入'
          })
        })
      },

      /**
       * 获取用户等级 用户id email
       */
      getAuthority() {
        getAuth().then(response => {
          // localStorage.setItem('authority', response.data.authority);
          // localStorage.setItem('customerId', response.data.customerId.id);
          // localStorage.setItem('email', response.data.email);

          localStorage.setItem('authority', this.$commonFun.compileStr(response.data.authority));
          localStorage.setItem('customerId', this.$commonFun.compileStr(response.data.customerId.id));
          localStorage.setItem('email', this.$commonFun.compileStr(response.data.email));
          if (response.data.authority === 'SYS_ADMIN') {
            this.$message({
              showClose: true,
              type:'warning',
              message: '用户名或密码错误，请重新输入'
            })
          } else {
            router.push({
              name: 'Home',
              path: '/Home',
              params: {authority: response.data.authority, customerId:response.data.customerId.id,}
            });
          }
        }).catch(error => {
          console.log("error",error);
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../less/Login";
</style>



// WEBPACK FOOTER //
// src/components/view/Login.vue